import React, { useEffect, useRef, useState } from "react";
import localeText from "../../../../locale";
import BannerCarousel from "../../../Shop/components/BannerCarousel/BannerCarousel";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import "./styles.css";
import BannerUpload from "./BannerUpload";
import { locale } from "../../../../utilities/locale/locale";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import ProductService from "../../../../service/ProductService";
import MarketplaceService from "../../../../service/Makertplace";
import Loading from "../../../../components/Loading/Loading";
import { Checkbox } from "primereact/checkbox";
import BestDeals from "../../../Shop/components/BestDeals/BestDeals";
import PrimaryBannerImg from "../../../images/pages/ad-banner1.png";
import Cropper from "react-cropper";
import { Dialog } from "primereact/dialog";

const MAIN_BANNER_RATIO = 3 / 1;
const SUB_BANNER_RATIO = 7 / 4;

const Banners = ({ title, type }) => {
  const [isLoadingBanners, setIsLoadingBanners] = useState(true);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);

  const [imageDesktopEnglish, setImageDesktopEnglish] = useState(null);
  const [imageDesktopItalian, setImageDesktopItalian] = useState(null);
  const [imageDesktopPortuguese, setImageDesktopPortuguese] = useState(null);
  const [imageDesktopSpanish, setImageDesktopSpanish] = useState(null);
  const [imageMobileEnglish, setImageMobileEnglish] = useState(null);
  const [imageMobileItalian, setImageMobileItalian] = useState(null);
  const [imageMobilePortuguese, setImageMobilePortuguese] = useState(null);
  const [imageMobileSpanish, setImageMobileSpanish] = useState(null);

  const [showBanner, setShowBanner] = useState(false);

  const [language, setLanguage] = useState(locale);
  const [languageMobile, setLanguageMobile] = useState(locale);

  const [isOpenCropModal, setIsOpenCropModal] = useState(false);

  const [actualImg, setActualImg] = useState();

  const [imagesBanners, setImagesBanners] = useState([
    {
      title: "imageDesktopEnglish",
      setImages: setImageDesktopEnglish,
      isChecked: false,
    },
    {
      title: "imageDesktopItalian",
      setImages: setImageDesktopItalian,
      isChecked: false,
    },
    {
      title: "imageDesktopPortuguese",
      setImages: setImageDesktopPortuguese,
      isChecked: false,
    },
    {
      title: "imageDesktopSpanish",
      setImages: setImageDesktopSpanish,
      isChecked: false,
    },
    { title: "imageMobileEnglish", setImages: setImageMobileEnglish, isChecked: false },
    { title: "imageMobileItalian", setImages: setImageMobileItalian, isChecked: false },
    {
      title: "imageMobilePortuguese",
      setImages: setImageMobilePortuguese,
      isChecked: false,
    },
    { title: "imageMobileSpanish", setImages: setImageMobileSpanish, isChecked: false },
  ]);

  const cropperRef = useRef(null);

  const { showErrorToast } = useToastContext();

  const productService = new ProductService();
  const marketplaceService = new MarketplaceService();

  const bannersLang = {
    en: imageDesktopEnglish,
    it: imageDesktopItalian,
    pt: imageDesktopPortuguese,
    es: imageDesktopSpanish,
  };

  const bannersMobileLang = {
    en: imageMobileEnglish,
    it: imageMobileItalian,
    pt: imageMobilePortuguese,
    es: imageMobileSpanish,
  };

  const bannersUploadComponets = [
    {
      images: imageDesktopEnglish,
      setImages: setImageDesktopEnglish,
      title: "imageDesktopEnglish",
    },
    {
      images: imageDesktopItalian,
      setImages: setImageDesktopItalian,
      title: "imageDesktopItalian",
    },
    {
      images: imageDesktopPortuguese,
      setImages: setImageDesktopPortuguese,
      title: "imageDesktopPortuguese",
    },
    {
      images: imageDesktopSpanish,
      setImages: setImageDesktopSpanish,
      title: "imageDesktopSpanish",
    },
    { images: imageMobileEnglish, setImages: setImageMobileEnglish, title: "imageMobileEnglish" },
    { images: imageMobileItalian, setImages: setImageMobileItalian, title: "imageMobileItalian" },
    {
      images: imageMobilePortuguese,
      setImages: setImageMobilePortuguese,
      title: "imageMobilePortuguese",
    },
    { images: imageMobileSpanish, setImages: setImageMobileSpanish, title: "imageMobileSpanish" },
  ];

  const languages = [
    { id: "english", value: "en", label: "english" },
    { id: "italian", value: "it", label: "italian" },
    { id: "portuguese", value: "pt", label: "portuguese" },
    { id: "spanish", value: "es", label: "spanish" },
  ];

  const previewImage = (files) => {
    if (typeof files === "string") return [{ id: 1, bgImg: files, cloudinary: true }];

    if (!Array.isArray(files) || files.length === 0) return [];

    if (!files) return [];

    return [{ id: 1, bgImg: URL.createObjectURL(files[0]) }];
  };

  const handleImagesUpload = async () => {
    try {
      setIsLoadingUpload(true);

      if (
        !imageDesktopEnglish &&
        !imageDesktopItalian &&
        !imageDesktopPortuguese &&
        !imageDesktopSpanish &&
        !imageMobileEnglish &&
        !imageMobileItalian &&
        !imageMobilePortuguese &&
        !imageMobileSpanish
      ) {
        showErrorToast({ detail: "noImageSelected" });
        return;
      }

      let imgPTDesktop = null;
      let imgITDesktop = null;
      let imgESDesktop = null;
      let imgENDesktop = null;
      let imgPTMobile = null;
      let imgITMobile = null;
      let imgESMobile = null;
      let imgENMobile = null;

      const imagesToUpload = [
        { image: imageDesktopEnglish, setter: (url) => (imgENDesktop = url) },
        { image: imageDesktopItalian, setter: (url) => (imgITDesktop = url) },
        { image: imageDesktopPortuguese, setter: (url) => (imgPTDesktop = url) },
        { image: imageDesktopSpanish, setter: (url) => (imgESDesktop = url) },
        { image: imageMobileEnglish, setter: (url) => (imgENMobile = url) },
        { image: imageMobileItalian, setter: (url) => (imgITMobile = url) },
        { image: imageMobilePortuguese, setter: (url) => (imgPTMobile = url) },
        { image: imageMobileSpanish, setter: (url) => (imgESMobile = url) },
      ];

      for (const { image, setter } of imagesToUpload) {
        if (image && typeof image !== "string") {
          const uploadedUrl = await handleImageUpload(image);
          setter(uploadedUrl);
        } else {
          setter(image);
        }
      }

      const data = {
        imageDesktopEnglish: imgENDesktop,
        imageDesktopItalian: imgITDesktop,
        imageDesktopPortuguese: imgPTDesktop,
        imageDesktopSpanish: imgESDesktop,
        imageMobileEnglish: imgENMobile,
        imageMobileItalian: imgITMobile,
        imageMobilePortuguese: imgPTMobile,
        imageMobileSpanish: imgESMobile,
        showImage: showBanner,
      };

      try {
        await marketplaceService.postUploadBannner(data, type);

        await getBanners();
      } catch (e) {
        if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
        else showErrorToast({ detail: "unexpectedErrorUploadImg" });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingUpload(false);
    }
  };

  const handleImageUpload = async (image) => {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image[0]
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
      }

      return res.result;
    } catch (e) {
      if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadImg" });
    }
  };

  const getBanners = async () => {
    try {
      const resBannners = await marketplaceService.getConfiguration();

      let bannersConfig;

      if (type === "main") {
        bannersConfig = resBannners?.result?.mainBanner;
      } else if (type === "sub1") {
        bannersConfig = resBannners?.result?.subBanner1;
      } else if (type === "sub2") {
        bannersConfig = resBannners?.result?.subBanner2;
      } else if (type === "sub3") {
        bannersConfig = resBannners?.result?.subBanner3;
      }

      const imageSetters = [
        { value: bannersConfig?.imageDesktopEnglish, setter: setImageDesktopEnglish },
        { value: bannersConfig?.imageDesktopItalian, setter: setImageDesktopItalian },
        { value: bannersConfig?.imageDesktopPortuguese, setter: setImageDesktopPortuguese },
        { value: bannersConfig?.imageDesktopSpanish, setter: setImageDesktopSpanish },
        { value: bannersConfig?.imageMobileEnglish, setter: setImageMobileEnglish },
        { value: bannersConfig?.imageMobileItalian, setter: setImageMobileItalian },
        { value: bannersConfig?.imageMobilePortuguese, setter: setImageMobilePortuguese },
        { value: bannersConfig?.imageMobileSpanish, setter: setImageMobileSpanish },
        { value: bannersConfig?.showImage, setter: setShowBanner },
      ];

      imageSetters.forEach(({ value, setter }) => {
        if (value) setter(value);
      });
    } catch (e) {
      showErrorToast({ code: 500000 });
      console.error(e);
    }
  };

  const initalgetBanners = async () => {
    try {
      setIsLoadingBanners(true);
      await getBanners();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingBanners(false);
    }
  };

  const renderBestDeals = () => {
    const image = previewImage(bannersLang[language]);

    if (type === "sub1") return <BestDeals image1={image} />;
    else if (type === "sub2") return <BestDeals image2={image} />;
    else if (type === "sub3") return <BestDeals image3={image} />;
    else return null;
  };

  const onSetImage = (img, setImg, title) => {
    const files = Array.from(img);
    const reader = new FileReader();

    reader.onload = () => {
      setActualImg({ img: reader.result, setImg: setImg, title: title });
      setIsOpenCropModal(true);
    };

    reader.readAsDataURL(files[0]);
  };

  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const getCroppedImage = () => {
    if (cropperRef.current) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL();

      const img = new Image();

      img.src = croppedImageBase64;

      img.onload = function () {
        const croppedImageFile = dataURLtoFile(croppedImageBase64, "croppedImage.png");

        actualImg.setImg([croppedImageFile]);

        imagesBanners.forEach((img) => {
          if (img.isChecked) img.setImages([croppedImageFile]);
        });
        setIsOpenCropModal(false);
      };
    }
  };

  useEffect(() => {
    initalgetBanners(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canRenderDesktopPreview =
    bannersLang[language] &&
    Array.isArray(previewImage(bannersLang[language])) &&
    previewImage(bannersLang[language]).length > 0;

  const canRenderMobilePreview =
    bannersMobileLang[languageMobile] &&
    Array.isArray(previewImage(bannersMobileLang[languageMobile])) &&
    previewImage(bannersMobileLang[languageMobile]).length > 0;

  return (
    <div className="card">
      <h3 className="my-3">{title} Upload</h3>

      {isLoadingBanners ? (
        <Loading classNameIcon={"text-4xl"} />
      ) : (
        <>
          {isOpenCropModal && (
            <Dialog
              header={`${localeText("keepImageInRequiredAspectRatio")} ${
                type === "main" ? ` (3 / 1)` : ` (7 / 4)`
              } - (${localeText(actualImg?.title)})`}
              visible={isOpenCropModal}
              onHide={() => {
                setIsOpenCropModal(false);
              }}
              breakpoints={{ "960px": "85vw" }}
              style={{ width: "50vw" }}
              draggable={false}
            >
              <Cropper
                ref={cropperRef}
                src={actualImg?.img}
                style={{ height: 400, width: "100%", marginBottom: 10 }}
                aspectRatio={type === "main" ? MAIN_BANNER_RATIO : SUB_BANNER_RATIO}
              />

              <div className="mb-4">
                <p>{localeText("doYouWantToRepeatThisImage")}</p>

                <div className="flex gap-2 justify-content-start flex-wrap">
                  {imagesBanners.map((banner) => {
                    if (banner.title === actualImg.title) return null;
                    return (
                      <div className="flex align-items-center">
                        <Checkbox
                          inputId={`${banner.title}`}
                          onChange={() => {
                            setImagesBanners((prev) =>
                              prev.map((img) =>
                                img.title === banner.title
                                  ? { ...img, isChecked: !img.isChecked }
                                  : img
                              )
                            );
                          }}
                          checked={
                            imagesBanners.find((img) => img.title === banner.title).isChecked ===
                            true
                          }
                        />

                        <label htmlFor={`${banner.title}`} className="ml-2">
                          <strong>{localeText(banner.title)}</strong>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="flex justify-content-end">
                <Button onClick={getCroppedImage}>{localeText("cropImage")}</Button>
              </div>
            </Dialog>
          )}

          <div>
            <div className="bannersContainer">
              {bannersUploadComponets.map(({ images, setImages, title }) => (
                <BannerUpload
                  key={title}
                  images={images}
                  setImages={(img) => onSetImage(img, setImages, title)}
                  title={title}
                />
              ))}

              <div className="flex align-items-center">
                <Checkbox
                  inputId="showBanner"
                  onChange={() => {
                    setShowBanner((prev) => !prev);
                  }}
                  checked={showBanner === true}
                />
                <label htmlFor="showBanner" className="ml-2">
                  {localeText("showBanner")}
                </label>
              </div>
            </div>

            <div className="flex justify-content-end mt-4">
              <Button
                size="large"
                label={localeText("save")}
                onClick={handleImagesUpload}
                loading={isLoadingUpload}
              />
            </div>

            <div className="content-grid bg-white">
              <div className="mt-4">
                <h5>Preview Desktop</h5>

                <div className="flex gap-2 xl:flex-row flex-column mb-4">
                  <label>{localeText("language")}:</label>
                  {languages.map(({ id, value, label }) => (
                    <div key={id}>
                      <RadioButton
                        inputId={`${id}`}
                        value={value}
                        onChange={(e) => setLanguage(e.value)}
                        checked={language === value}
                      />
                      <label htmlFor={`${id}`} className="pl-2 cursor-pointer">
                        {localeText(label)}
                      </label>
                    </div>
                  ))}
                </div>

                {canRenderDesktopPreview ? (
                  <>
                    {type === "main" ? (
                      <>
                        <div>
                          <BannerCarousel items={previewImage(bannersLang[language])} />
                        </div>
                        <BestDeals />
                      </>
                    ) : (
                      <>
                        <div>
                          <BannerCarousel items={[{ id: 1, bgImg: PrimaryBannerImg }]} />
                        </div>
                        {renderBestDeals()}
                      </>
                    )}
                  </>
                ) : (
                  <p>{localeText("dontHaveImage")}</p>
                )}
              </div>

              <div className="mt-4">
                <h5>Preview Mobile - 350px</h5>

                <div className="flex gap-2 xl:flex-row flex-column mb-4">
                  {languages.map(({ id, value, label }) => (
                    <div key={id}>
                      <RadioButton
                        inputId={`${id}-mobile`}
                        value={value}
                        onChange={(e) => setLanguageMobile(e.value)}
                        checked={languageMobile === value}
                      />
                      <label htmlFor={`${id}-mobile`} className="pl-2 cursor-pointer">
                        {localeText(label)}
                      </label>
                    </div>
                  ))}
                </div>

                <div style={{ maxWidth: "350px" }}>
                  {canRenderMobilePreview ? (
                    <>
                      {type === "main" ? (
                        <>
                          <div>
                            <BannerCarousel
                              items={previewImage(bannersMobileLang[languageMobile])}
                            />
                          </div>
                          <BestDeals />
                        </>
                      ) : (
                        <>
                          <div>
                            <BannerCarousel items={[{ id: 1, bgImg: PrimaryBannerImg }]} />
                          </div>

                          {renderBestDeals()}
                        </>
                      )}
                    </>
                  ) : (
                    <p>{localeText("dontHaveImage")}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Banners;
